import { useApplicationStore } from '@data';
import { useIsLoggedIn } from '@hooks/useIsLoggedIn';
import {
  fetchPatientSubscriptions,
  fetchSubscriptionsAvailableToPatient,
} from 'api/subscriptions';
import React from 'react';
import { useShallow } from 'zustand/shallow';

export const usePatientSubscriptions = () => {
  const { isLoggedIn } = useIsLoggedIn();

  const {
    patientSubscriptions,
    setPatientSubscriptions,
    subscriptionsAvailableToPatient,
    setSubscriptionsAvailableToPatient,
  } = useApplicationStore(
    useShallow(({ patient }) => ({
      patientSubscriptions: patient.patientSubscriptions,
      setPatientSubscriptions: patient.setPatientSubscriptions,
      subscriptionsAvailableToPatient: patient.subscriptionsAvailableToPatient,
      setSubscriptionsAvailableToPatient:
        patient.setSubscriptionsAvailableToPatient,
    })),
  );

  React.useEffect(() => {
    if (!isLoggedIn || subscriptionsAvailableToPatient) {
      return;
    }
    (async () => {
      const subscriptions = await fetchSubscriptionsAvailableToPatient();
      setSubscriptionsAvailableToPatient(subscriptions);
    })();
  }, [
    subscriptionsAvailableToPatient,
    setSubscriptionsAvailableToPatient,
    isLoggedIn,
  ]);

  React.useEffect(() => {
    if (!isLoggedIn || patientSubscriptions) return;
    (async () => {
      const subscriptions = await fetchPatientSubscriptions();
      setPatientSubscriptions(subscriptions);
    })();
  }, [patientSubscriptions, setPatientSubscriptions, isLoggedIn]);

  const patientSubscriptionsLoading = !patientSubscriptions;
  const subscriptionsAvailableToPatientLoading =
    !subscriptionsAvailableToPatient;
  const loading =
    patientSubscriptionsLoading || subscriptionsAvailableToPatientLoading;

  return {
    patientSubscriptions,
    subscriptionsAvailableToPatient,
    loading: loading
      ? { patientSubscriptionsLoading, subscriptionsAvailableToPatientLoading }
      : undefined,
  };
};
